import _taggedTemplateLiteral from "/app/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/taggedTemplateLiteral.js";

var _templateObject;

import { Box, styled } from '@mui/material';
export var ProfileEditorWrapper = styled(Box)(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n  padding: ", ";\n  max-width: 700px;\n  width: 75vw;\n  position: relative;\n"])), function (p) {
  return p.theme.spacing(2, 0);
});